import { call, put, all, takeEvery } from 'redux-saga/effects';

import { removeError, setError, sendError, sendNetworkError } from 'reducers/errorReducer';
import { sendRequest,sendNetworkErrorRequest } from 'apis/errorApi';

function* sendSaga(action: ReturnType<typeof sendError>) {
  try {
    yield call(sendRequest, action.payload);
    yield put(removeError());
  } catch (error) {
    // yield put(setError(action.payload));
  }
}

function* sendNetworkSaga(action: ReturnType<typeof sendError>) {
  try {
    yield call(sendNetworkErrorRequest, action.payload);
    yield put(removeError());
  } catch (error) {
    // yield put(setError(action.payload));
  }
}
export default function* errorSaga() {
  yield all([takeEvery(sendError, sendSaga)]);
  yield all([takeEvery(sendNetworkError, sendNetworkSaga)]);
}
